import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles(
  _theme => ({
    deleteButton: {
      "& > span": {
        color: "red"
      },
      padding: "6px 12px",
      width: 120
    },
    footerButtonsContainer: {
      display: "flex",
      gap: "8px",
      margin: "48px auto -18px",
      width: "fit-content"
    },
    retainButton: {
      padding: "6px 18px",
      width: 120
    },
    subContent: {
      color: "#747C8C",
      fontSize: "14px",
      padding: "0 1em",
      textAlign: "center"
    }
  }),
  { name: "DeleteWarnDialog" }
);
